<template>
    <paper-section>
        <div class="product__brochure">
            <h1 class="shop__heading product__mobile-heading" v-text="$t('SHOP_PRODUCT_CARE')"></h1>
            <div class="product__brochure__container">
                <img :src="image" />
            </div>
            <div class="product__brochure__container">
                <h1 class="shop__heading product__heading" v-text="$t('SHOP_PRODUCT_CARE')"></h1>
                <p class="shop__paragraph mt-4" v-html="careInformation"></p>
            </div>
        </div>
    </paper-section>
</template>

<script>
import PaperSection from '@/components/structure/PaperSection';

export default {
    name: 'BrochureSection',
    components: { PaperSection },
    props: {
        image: {
            required: true,
            type: String,
        },
        careInformation: {
            required: true,
            type: String,
        },
    },
};
</script>
